import api from "./axiosConfig";

export const getCurrentInvoices = async () => {
    const apiData = api.get("/dashboard/currentMonthInvoices")
    return apiData
}

export const getSalesData = async (year: number, staff?: string) => {
  if (staff) {
    return api.get(`/dashboard/invoiceTrendByYear/${year}/${staff}`)
  } else {
    return api.get(`/dashboard/invoiceTrendByYear/${year}`)
  }
}

export const getStaffTrendsInterface = async (category: number, year: number, month: number) => {
  const cate = category === 0 ? "tsubo" : category === 1 ? "arrival" : "shipping"
  return api.get(`/dashboard/staffTrendsByYear/${cate}/${year}/${month}`)
}

export const getWarehouseTrendsInterface = async (category: number, year: number) => {
  const cate = category === 0 ? "tsubo" : category === 1 ? "arrival" : "shipping"
  return api.get(`/dashboard/warehouseTrendsByYear/${cate}/${year}`)
}